var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-banner"},[_c('span',{staticClass:"offer-banner_value"},[_vm._t("value")],2),_c('p',{staticClass:"offer-banner_text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }